import { useState } from 'react';
import { useNotification } from '../../../../contexts/NotificationContext';

export const FEEDBACK_FORM_INITIAL_STATE = {
  uhid_no: '',
  mobile_no: '',
  feedback_date: '',
  feedback_reason: '',
  other_reason: '',
  doctor_name: '',
};

const DOCTOR_LIST = [
  { id: 1, name: "Dr. Alice Smith" },
  { id: 2, name: "Dr. John Doe" },
  { id: 3, name: "Dr. Emily Johnson" },
  { id: 4, name: "Dr. Michael Brown" },
  { id: 5, name: "Dr. Sarah Davis" },
  { id: 6, name: "Dr. David Wilson" },
  { id: 7, name: "Dr. Laura Taylor" },
  { id: 8, name: "Dr. James Anderson" },
  { id: 9, name: "Dr. Olivia Thomas" },
  { id: 10, name: "Dr. Daniel Martinez" },
];

export const useFeedbackForm = (initialData = FEEDBACK_FORM_INITIAL_STATE) => {
  const { showNotification } = useNotification();
  const [formData, setFormData] = useState(initialData);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handlePhoneChange = (value) => {
    setFormData(prev => ({ ...prev, mobile_no: value }));
  };

  const validate = () => {
    if (!formData.uhid_no) { showNotification('error', 'Required: Please select a Patient UHID.'); return false; }
    if (!formData.feedback_date) { showNotification('error', 'Required: Please select a Feedback Date.'); return false; }
    if (!formData.doctor_name) { showNotification('error', 'Required: Please select a Doctor.'); return false; }
    if (!formData.feedback_reason) { showNotification('error', 'Required: Please select a Feedback Reason.'); return false; }
    if (formData.feedback_reason === 'Others' && !formData.other_reason) {
      showNotification('error', 'Required: Please specify the other reason.');
      return false;
    }
    return true;
  };

  const buildPayload = () => ({
    uhid_no: formData.uhid_no,
    mobile_no: formData.mobile_no,
    feedback_date: formData.feedback_date,
    feedback_reason: formData.feedback_reason,
    other_reason: formData.feedback_reason === 'Others' ? formData.other_reason : null,
    doctor_name: formData.doctor_name,
  });

  return { formData, DOCTOR_LIST, handleChange, handlePhoneChange, validate, buildPayload };
};
